enum LicensesActions {
    FETCH_LIST = "licensesFetchList",
    GET_ITEM = "licensesGetItem",
    CREATE_ITEM = "licensesCreateItem",
    UPDATE_ITEM = "licensesUpdateItem",
    DELETE_ITEM = "licensesDeleteItem",
    REFRESH_LIST = "licensesRefreshList",

    // License Modules
    FETCH_LICENSE_MODULES = "licensesFetchLicenseModules",
    SAVE_LICENSE_MODULES = "licensesSaveLicenseModules",

    // System Modules
    FETCH_SYSTEM_MODULES = "licensesFetchSystemModules",
    GET_SYSTEM_MODULE = "licensesGetSystemModule",
    CREATE_SYSTEM_MODULE = "licensesCreateSystemModule",
    UPDATE_SYSTEM_MODULE = "licensesUpdateSystemModule",
    DELETE_SYSTEM_MODULE = "licensesDeleteSystemModule",
    REORDER_SYSTEM_MODULES = "licensesReorderSystemModules",
    REFRESH_SYSTEM_MODULES = "licensesRefreshSystemModules",

    // Dashboard Widgets
    FETCH_DASHBOARD_WIDGETS = "licensesFetchDashboardWidgets",
    GET_DASHBOARD_WIDGET = "licensesGetDashboardWidget",
    CREATE_DASHBOARD_WIDGET = "licensesCreateDashboardWidget",
    UPDATE_DASHBOARD_WIDGET = "licensesUpdateDashboardWidget",
    DELETE_DASHBOARD_WIDGET = "licensesDeleteDashboardWidget",
    REFRESH_DASHBOARD_WIDGETS = "licensesRefreshDashboardWidgets",

    // Notification Events
    FETCH_NOTIFICATION_EVENTS = "licensesFetchNotificationEvents",
    GET_NOTIFICATION_EVENT = "licensesGetNotificationEvent",
    CREATE_NOTIFICATION_EVENT = "licensesCreateNotificationEvent",
    UPDATE_NOTIFICATION_EVENT = "licensesUpdateNotificationEvent",
    DELETE_NOTIFICATION_EVENT = "licensesDeleteNotificationEvent",
    REFRESH_NOTIFICATION_EVENTS = "licensesRefreshNotificationEvents",

    // Role Identifiers
    FETCH_ROLE_IDENTIFIERS = "licensesFetchRoleIdentifiers",

    // Internal Users
    FETCH_INTERNAL_USERS = "licensesFetchInternalUsers",

    // API Registry
    FETCH_API_REGISTRY = "licensesFetchApiRegistry",

    // Block Categories
    FETCH_BLOCK_CATEGORIES = "licensesFetchBlockCategories",
    CREATE_BLOCK_CATEGORY = "licensesCreateBlockCategory",
    UPDATE_BLOCK_CATEGORY = "licensesUpdateBlockCategory",
    DELETE_BLOCK_CATEGORY = "licensesDeleteBlockCategory",

    // System Blocks
    FETCH_SYSTEM_BLOCKS = "licensesFetchSystemBlocks",
    GET_SYSTEM_BLOCK = "licensesGetSystemBlock",
    CREATE_SYSTEM_BLOCK = "licensesCreateSystemBlock",
    UPDATE_SYSTEM_BLOCK = "licensesUpdateSystemBlock",
    DELETE_SYSTEM_BLOCK = "licensesDeleteSystemBlock",
    REFRESH_SYSTEM_BLOCKS = "licensesRefreshSystemBlocks",

    // Resolve URLs
    FETCH_RESOLVE_URLS = "licensesFetchResolveUrls",
    GET_RESOLVE_URL = "licensesGetResolveUrl",
    CREATE_RESOLVE_URL = "licensesCreateResolveUrl",
    UPDATE_RESOLVE_URL = "licensesUpdateResolveUrl",
    DELETE_RESOLVE_URL = "licensesDeleteResolveUrl",
    REFRESH_RESOLVE_URLS = "licensesRefreshResolveUrls",

    // DEV DB Sync
    DEV_SYNC_INFO = "licensesDevSyncInfo",
    DEV_SYNC_TRIGGER = "licensesDevSyncTrigger",
    DEV_SYNC_STATUS = "licensesDevSyncStatus"
}

enum LicensesMutation {
    SET_RENDER_UPDATE = "licensesListRenderNeeded",
    SET_LIST_RESULT = "licensesListResult",
    SET_LICENSE_MODULES = "licensesLicenseModulesResult",
    SET_SYSTEM_MODULES_RESULT = "licensesSystemModulesResult",
    SET_DASHBOARD_WIDGETS_RESULT = "licensesDashboardWidgetsResult",
    SET_NOTIFICATION_EVENTS_RESULT = "licensesNotificationEventsResult",
    SET_BLOCK_CATEGORIES_RESULT = "licensesBlockCategoriesResult",
    SET_SYSTEM_BLOCKS_RESULT = "licensesSystemBlocksResult",
    SET_RESOLVE_URLS_RESULT = "licensesResolveUrlsResult"
}

export {LicensesActions, LicensesMutation};
